module.exports = __webpack_public_path__ + "static/media/turbo_cwu_off.3083db7e.svg";